module.exports = __webpack_public_path__ + "static/media/word.4e13cdd2.svg";